/**
 *  Created by piotr@revisual.io on 15/08/2025
 */
import { orderQuotas } from "../../helpers/subscription";
import { useCurrentOrganizationStore } from "../../../../hooks/redux/currentOrganization";
import { hasSubscription } from "../../helpers/organization";
import { QUOTAS } from "../../../../consts";
import { useMemo } from "react";
import classNames from "classnames";
import ComparisonBar from "./ComparisonBar";

/**
 *
 * @param {number} newLimit
 * @param {number} limit
 * @param {number} usage
 * @returns {JSX.Element}
 * @constructor
 */
const PricingComparisonBar = ({ newLimit, limit, usage }) => {
  const numberFormatter = Intl.NumberFormat(window.navigator.locale || "en-US");
  return (
    <div className={"plan-comparison-table-item-detail"}>
      <div className={"plan-comparison-table-item-detail-item"}>
        Current Plan usage:{" "}
        <span>
          {numberFormatter.format(usage)} /{" "}
          {limit !== -1 ? numberFormatter.format(limit) : "Unlimited"}
        </span>
      </div>

      <ComparisonBar usage={usage} limit={limit} />
      <div className={"plan-comparison-table-item-detail-item"}>
        New Plan usage:{" "}
        <span>
          {numberFormatter.format(usage)} / {numberFormatter.format(newLimit)}
        </span>
      </div>

      <ComparisonBar usage={usage} limit={newLimit} />
    </div>
    /*<div className={"comparison-bar"}>
      <div className={"comparison-bar-new-limit"} style={newUsageStyle}></div>
      <div className={"comparison-bar-old-limit"} style={usageStyle}></div>
    </div>*/
  );
};

export default PricingComparisonBar;
